import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import rehypeHighlight from "rehype-highlight";
import remarkGfm from "remark-gfm";
import "highlight.js/styles/github-dark.css";
import AdComponent from './AdComponent';
import EightBitSimulator from './EightBitSimulator';
import './css/markdown.css';
interface DocItem {
  name: string;
  title: string;
  category: string;
  route?: string;
}

type DocMenus = {
  [key: string]: DocItem[];
};

type GroupedDocs = {
  [category: string]: DocItem[];
};

function MarkdownPage() {
  const { lang, docName } = useParams<{ lang: string; docName: string }>();
  const [content, setContent] = useState<string>("");
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(() => {
    if (typeof window === "undefined") return true;
    return window.innerWidth > 768;
  });

  // 언어별 문서 목록 (실제로는 API에서 가져올 수 있음)
  const docMenus: DocMenus = {
    c: [
        { name: "variable", title: "변수", category: "기본" },
        { name: "list", title: "리스트", category: "기본" },
        { name: "array-string", title: "배열과 문자열", category: "기본" },
        { name: "pointer", title: "포인터", category: "기본" },
        { name: "scanf", title: "입력", category: "기본" },
        { name: "if", title: "조건문", category: "기본" },
        { name: "for", title: "반복문 for", category: "기본" },
        { name: "while", title: "반복문 while", category: "기본" },
        { name: "function", title: "함수", category: "기본" },
        { name: "struct-typedef", title: "구조체와 typedef", category: "중급" },
        { name: "file-io", title: "파일 입출력", category: "응용" },
        { name: "time", title: "시간 측정", category: "응용" },
        { name: "stack-queue", title: "스택/큐", category: "응용" },
        {name : "productmanager", title : "상품관리프로그램", category : "기본"},
      ],
    csharp: [
      { name: "intro", title: "C#과 .NET 소개", category: "시작하기" },
      { name: "install-run", title: "설치와 첫 실행", category: "시작하기" },
      { name: "variable", title: "변수와 자료형", category: "기본" },
      { name: "input", title: "콘솔 입력", category: "기본" },
      { name: "if", title: "조건문", category: "기본" },
      { name: "for", title: "for와 foreach", category: "기본" },
      { name: "while", title: "while 반복문", category: "기본" },
      { name: "array-list", title: "배열과 List", category: "기본" },
      { name: "string", title: "문자열", category: "기본" },
      { name: "method", title: "메서드", category: "기본" },
      { name: "class-object", title: "클래스와 객체", category: "객체지향" },
      { name: "inheritance-interface", title: "상속과 인터페이스", category: "객체지향" },
      { name: "exception", title: "예외 처리", category: "중급" },
      { name: "file-io", title: "파일 입출력", category: "응용" },
      { name: "collections-linq", title: "컬렉션과 LINQ", category: "응용" },
      { name: "async-await", title: "비동기 프로그래밍", category: "응용" },
      { name: "time", title: "날짜와 시간 측정", category: "응용" },
      { name: "productmanager", title: "상품 관리 프로그램", category: "미니 프로젝트" },
      { name: "complete", title: "학습 마무리", category: "미니 프로젝트" },
    ],
    cpp: [
      { name: "intro", title: "C++ 소개와 실행", category: "시작하기" },
      { name: "variable", title: "변수와 자료형", category: "기본" },
      { name: "input-output", title: "cin과 cout 입출력", category: "기본" },
      { name: "if", title: "조건문", category: "기본" },
      { name: "for", title: "for 반복문", category: "기본" },
      { name: "while", title: "while 반복문", category: "기본" },
      { name: "function", title: "함수와 오버로딩", category: "기본" },
      { name: "array-string", title: "배열과 string", category: "기본" },
      { name: "reference-pointer", title: "참조자와 포인터", category: "중급" },
      { name: "class-object", title: "클래스와 객체", category: "객체지향" },
      { name: "constructor", title: "생성자와 캡슐화", category: "객체지향" },
      { name: "inheritance", title: "상속과 다형성", category: "객체지향" },
      { name: "vector", title: "vector와 STL", category: "STL" },
      { name: "file-io", title: "파일 입출력", category: "응용" },
      { name: "product-manager", title: "상품 관리 프로그램", category: "미니 프로젝트" },
    ],
    java: [
      { name: "intro", title: "Java 소개", category: "시작하기" },
      { name: "install-run", title: "설치와 첫 실행", category: "시작하기" },
      { name: "variable", title: "변수와 자료형", category: "기본" },
      { name: "input", title: "Scanner 입력", category: "기본" },
      { name: "operator", title: "연산자", category: "기본" },
      { name: "if", title: "조건문", category: "기본" },
      { name: "for", title: "for 반복문", category: "기본" },
      { name: "while", title: "while 반복문", category: "기본" },
      { name: "array", title: "배열", category: "기본" },
      { name: "string", title: "문자열", category: "기본" },
      { name: "method", title: "메서드", category: "기본" },
      { name: "class-object", title: "클래스와 객체", category: "객체지향" },
      { name: "constructor", title: "생성자와 캡슐화", category: "객체지향" },
      { name: "inheritance-interface", title: "상속과 인터페이스", category: "객체지향" },
      { name: "exception", title: "예외 처리", category: "중급" },
      { name: "collections", title: "컬렉션", category: "응용" },
      { name: "file-io", title: "파일 입출력", category: "응용" },
      { name: "product-manager", title: "상품 관리 프로그램", category: "미니 프로젝트" },
    ],
    html: [
      { name: "intro", title: "HTML 소개", category: "시작하기" },
      { name: "first-page", title: "첫 HTML 문서", category: "시작하기" },
      { name: "text", title: "제목과 문단", category: "콘텐츠" },
      { name: "links-paths", title: "링크와 경로", category: "콘텐츠" },
      { name: "images", title: "이미지", category: "콘텐츠" },
      { name: "lists", title: "목록", category: "콘텐츠" },
      { name: "tables", title: "표", category: "구조화" },
      { name: "block-inline", title: "블록과 인라인", category: "구조화" },
      { name: "semantic", title: "시맨틱 태그", category: "구조화" },
      { name: "forms", title: "폼과 입력", category: "폼과 접근성" },
      { name: "accessibility", title: "HTML 접근성", category: "폼과 접근성" },
      { name: "head-meta", title: "head와 메타데이터", category: "문서 설정" },
      { name: "media", title: "오디오와 비디오", category: "문서 설정" },
      { name: "css-connect", title: "CSS 연결", category: "완성하기" },
      { name: "validation", title: "검사와 디버깅", category: "완성하기" },
      { name: "profile-project", title: "소개 페이지 만들기", category: "미니 프로젝트" },
    ],
    css: [
      { name: "intro", title: "CSS 소개", category: "시작하기" },
      { name: "connect", title: "CSS 연결하기", category: "시작하기" },
      { name: "selectors", title: "선택자", category: "기본" },
      { name: "cascade-specificity", title: "상속과 우선순위", category: "기본" },
      { name: "colors-units", title: "색상과 단위", category: "기본" },
      { name: "box-model", title: "박스 모델", category: "기본" },
      { name: "typography", title: "글꼴과 텍스트", category: "표현" },
      { name: "backgrounds-borders", title: "배경과 테두리", category: "표현" },
      { name: "display", title: "display와 요소 흐름", category: "레이아웃" },
      { name: "flexbox", title: "Flexbox", category: "레이아웃" },
      { name: "grid", title: "Grid", category: "레이아웃" },
      { name: "position", title: "position과 겹침", category: "레이아웃" },
      { name: "responsive", title: "반응형 디자인", category: "반응형" },
      { name: "pseudo", title: "가상 클래스와 요소", category: "상호작용" },
      { name: "forms-ui", title: "폼과 버튼 스타일", category: "상호작용" },
      { name: "transitions", title: "전환과 애니메이션", category: "상호작용" },
      { name: "variables-debugging", title: "변수와 디버깅", category: "완성하기" },
      { name: "profile-project", title: "소개 페이지 꾸미기", category: "미니 프로젝트" },
    ],
    javascript: [
      { name: "intro", title: "JavaScript 소개", category: "시작하기" },
      { name: "connect-run", title: "연결과 실행", category: "시작하기" },
      { name: "variables-types", title: "변수와 자료형", category: "기본 문법" },
      { name: "operators", title: "연산자", category: "기본 문법" },
      { name: "if-switch", title: "조건문", category: "기본 문법" },
      { name: "loops", title: "반복문", category: "기본 문법" },
      { name: "function", title: "함수", category: "함수와 데이터" },
      { name: "scope", title: "스코프와 값", category: "함수와 데이터" },
      { name: "array", title: "배열", category: "함수와 데이터" },
      { name: "object", title: "객체", category: "함수와 데이터" },
      { name: "string", title: "문자열", category: "함수와 데이터" },
      { name: "modern-syntax", title: "구조 분해와 전개 문법", category: "함수와 데이터" },
      { name: "dom", title: "DOM 선택과 변경", category: "브라우저" },
      { name: "events", title: "이벤트", category: "브라우저" },
      { name: "forms", title: "폼 처리", category: "브라우저" },
      { name: "async", title: "Promise와 async/await", category: "비동기" },
      { name: "fetch", title: "fetch API", category: "비동기" },
      { name: "modules-errors", title: "모듈과 오류 처리", category: "코드 관리" },
      { name: "storage", title: "localStorage", category: "코드 관리" },
      { name: "todo-project", title: "할 일 관리 앱", category: "미니 프로젝트" },
    ],
    system: [
      { name: "complete", title: "학습 목차", category: "학습 순서" },
      { name: "overview", title: "전체 지도", category: "학습 순서" },
      { name: "linux-environment", title: "리눅스 접속과 환경 확인", category: "리눅스 실습" },
      { name: "process-observation", title: "프로세스 관찰", category: "리눅스 실습" },
      { name: "process-control", title: "백그라운드와 종료", category: "리눅스 실습" },
      { name: "permissions", title: "사용자와 권한", category: "리눅스 실습" },
      { name: "c-build", title: "C 컴파일과 실행", category: "C와 메모리" },
      { name: "pointer", title: "포인터와 메모리", category: "C와 메모리" },
      { name: "process", title: "프로세스 개념", category: "프로세스 API" },
      { name: "fork", title: "fork 프로세스 복제", category: "프로세스 API" },
      { name: "wait", title: "wait 자식 종료 대기", category: "프로세스 API" },
      { name: "exec", title: "exec 실행 교체", category: "프로세스 API" },
      { name: "process-exit", title: "프로세스 종료", category: "프로세스 API" },
      { name: "signal", title: "시그널", category: "시그널과 IPC" },
      { name: "ipc", title: "IPC와 파이프", category: "시그널과 IPC" },
      { name: "pipe-exec", title: "파이프와 exec 연결", category: "시그널과 IPC" },
      { name: "file-descriptor", title: "파일 디스크립터", category: "시그널과 IPC" },
      { name: "print-practice", title: "프린트 실습 흐름 정리", category: "복습 자료" },
      { name: "commands", title: "명령어 모음", category: "복습 자료" },
      { name: "c-functions", title: "C 함수 모음", category: "복습 자료" },
      { name: "faq", title: "자주 헷갈리는 것", category: "복습 자료" },
      { name: "exam", title: "시험 핵심 답안", category: "복습 자료" },
      { name: "debugging", title: "디버깅 체크리스트", category: "복습 자료" },
      { name: "summary", title: "마지막 압축 정리", category: "복습 자료" },
      { name: "mini-shell", title: "명령 실행기", category: "미니 프로젝트" },
      { name: "mini-pipe", title: "메시지 전달", category: "미니 프로젝트" },
    ],
    logic: [
      { name: "number-systems", title: "진수 설명", category: "수 체계와 표현" },
      { name: "binary-arithmetic", title: "2진수 연산", category: "수 체계와 표현" },
      { name: "digital-logic-circuit", title: "디지털 논리회로", category: "논리 게이트와 회로" },
      { name: "8bit-intro", title: "1. 4→8비트 제작 계획", category: "8비트 컴퓨터 만들기" },
      { name: "8bit-power-clock", title: "2. 4비트 전원과 클록", category: "8비트 컴퓨터 만들기" },
      { name: "8bit-logic-bus", title: "3. 4비트 게이트와 버스", category: "8비트 컴퓨터 만들기" },
      { name: "8bit-register-alu", title: "4. 4비트 레지스터와 ALU", category: "8비트 컴퓨터 만들기" },
      { name: "8bit-address-ram", title: "5. 4비트 컴퓨터 완성", category: "8비트 컴퓨터 만들기" },
      { name: "8bit-control", title: "6. 8비트 업그레이드", category: "8비트 컴퓨터 만들기" },
      { name: "8bit-test", title: "7. 통합과 웹 시험", category: "8비트 컴퓨터 만들기" },
      { name: "8bit-reference", title: "8. 핀 역할·배치·고장 진단", category: "8비트 컴퓨터 만들기" },
    ],
    linux: [
      { name: "intro", title: "리눅스 소개", category: "기본" },
      { name: "windows-diff", title: "Windows와 차이점", category: "기본" },
      { name: "dir-structure", title: "디렉토리의 구조", category: "기본" },
      { name: "path-types", title: "상대/절대 경로", category: "기본" },
      { name: "pwd", title: "pwd", category: "명령어" },
      { name: "ls", title: "ls", category: "명령어" },
      { name: "mv", title: "mv", category: "명령어" },
      { name: "cd", title: "cd", category: "명령어" },
      { name: "mkdir", title: "mkdir", category: "명령어" },
      { name: "touch", title: "touch", category: "명령어" },
      { name: "nano", title: "nano", category: "명령어" },
      { name: "gcc-install", title: "GCC 설치", category: "C 언어" },
      { name: "c-run", title: "C 언어 실행", category: "C 언어" },
    ],
    python: [
      { name: "intro", title: "파이썬 소개", category: "기본" },
      { name: "run", title: "파이썬 실행", category: "기본" },
      { name: "import", title: "import 기본", category: "기본" },
      { name: "variable", title: "변수", category: "기본" },
      { name: "input", title: "입력", category: "기본" },
      { name: "if", title: "조건문", category: "기본" },
      { name: "for", title: "for 반복문", category: "반복문" },
      { name: "while", title: "while 반복문", category: "반복문" },
      { name: "list", title: "리스트", category: "컬렉션" },
      { name: "function", title: "함수", category: "함수" },
    ],
    nextjs: [
      { name: "intro", title: "Next.js 소개", category: "시작하기" },
      { name: "setup", title: "설치와 첫 실행", category: "시작하기" },
      { name: "project-structure", title: "프로젝트 구조", category: "기본 구조" },
      { name: "pages-layouts", title: "페이지와 레이아웃", category: "기본 구조" },
      { name: "navigation", title: "링크와 동적 라우팅", category: "라우팅" },
      { name: "server-client", title: "서버와 클라이언트 컴포넌트", category: "렌더링" },
      { name: "styling-assets", title: "스타일·이미지·폰트", category: "화면 구성" },
      { name: "data-fetching", title: "데이터 가져오기", category: "데이터" },
      { name: "loading-error", title: "로딩과 오류 처리", category: "데이터" },
      { name: "route-handlers", title: "Route Handler API", category: "서버 기능" },
      { name: "server-actions", title: "폼과 Server Action", category: "서버 기능" },
      { name: "metadata-deploy", title: "메타데이터와 배포", category: "완성하기" },
      { name: "mini-project", title: "미니 프로젝트", category: "완성하기" },
    ],
    git: [
      { name: "intro", title: "Git과 GitHub 차이", category: "시작하기" },
      { name: "github-account", title: "계정과 SSH 인증", category: "GitHub 기초" },
      { name: "github", title: "리포지토리 만들기", category: "GitHub 기초" },
      { name: "github-flow", title: "브랜치와 Pull Request", category: "브랜치와 PR" },
      { name: "github-collaboration", title: "Fork와 코드 리뷰", category: "협업" },
      { name: "github-issues", title: "Issues와 Projects", category: "협업" },
      { name: "github-security", title: "권한과 저장소 보안", category: "권한과 보안" },
      { name: "github-actions", title: "GitHub Actions 자동화", category: "자동화" },
      { name: "github-releases", title: "Release와 Pages", category: "배포와 공개" },
      { name: "git-version", title: "git --version", category: "설정과 시작" },
      { name: "git-config", title: "git config", category: "설정과 시작" },
      { name: "git-init", title: "git init", category: "설정과 시작" },
      { name: "git-clone", title: "git clone", category: "설정과 시작" },
      { name: "git-status", title: "git status", category: "변경 기록" },
      { name: "git-add", title: "git add", category: "변경 기록" },
      { name: "git-diff", title: "git diff", category: "변경 기록" },
      { name: "git-commit", title: "git commit", category: "변경 기록" },
      { name: "git-log", title: "git log", category: "변경 기록" },
      { name: "git-branch", title: "git branch", category: "브랜치" },
      { name: "git-switch", title: "git switch", category: "브랜치" },
      { name: "git-merge", title: "git merge", category: "브랜치" },
      { name: "git-remote", title: "git remote", category: "원격 저장소" },
      { name: "git-push", title: "git push", category: "원격 저장소" },
      { name: "git-fetch", title: "git fetch", category: "원격 저장소" },
      { name: "git-pull", title: "git pull", category: "원격 저장소" },
      { name: "git-restore", title: "git restore", category: "되돌리기와 임시 보관" },
      { name: "git-reset", title: "git reset", category: "되돌리기와 임시 보관" },
      { name: "git-revert", title: "git revert", category: "되돌리기와 임시 보관" },
      { name: "git-stash", title: "git stash", category: "되돌리기와 임시 보관" },
      { name: "git-tag", title: "git tag", category: "버전 관리" },
      { name: "git-workflow", title: "로컬 ↔ 원격 실전 흐름", category: "실전 흐름" },
      { name: "git-conflict", title: "충돌 해결과 되돌리기", category: "문제 해결" },
      { name: "gitignore", title: ".gitignore와 보안", category: "문제 해결" },
    ],
    firebase: [
      { name: "intro", title: "Firebase란 무엇인가", category: "시작하기" },
      { name: "project", title: "프로젝트와 앱 연결", category: "시작하기" },
      { name: "firebase-cli", title: "Firebase CLI와 설정 파일", category: "CLI 기초" },
      { name: "firebase-login", title: "firebase login", category: "CLI 명령어" },
      { name: "firebase-init", title: "firebase init", category: "CLI 명령어" },
      { name: "firebase-use", title: "firebase use", category: "CLI 명령어" },
      { name: "firebase-emulators", title: "firebase emulators", category: "CLI 명령어" },
      { name: "firebase-deploy", title: "firebase deploy", category: "CLI 명령어" },
      { name: "auth", title: "Authentication 로그인", category: "Firebase 서비스" },
      { name: "firestore", title: "Cloud Firestore 데이터베이스", category: "Firebase 서비스" },
      { name: "storage", title: "Cloud Storage 파일 저장", category: "Firebase 서비스" },
      { name: "functions", title: "Cloud Functions 서버 코드", category: "Firebase 서비스" },
      { name: "hosting", title: "Firebase Hosting 배포", category: "Firebase 서비스" },
      { name: "rules", title: "Security Rules 보안 규칙", category: "보안과 운영" },
      { name: "github-actions", title: "GitHub Actions 자동 배포", category: "보안과 운영" },
    ],
    vercel: [
      { name: "intro", title: "Vercel이란 무엇인가", category: "시작하기" },
      { name: "prepare", title: "배포 전 프로젝트 준비", category: "시작하기" },
      { name: "account-project", title: "계정과 프로젝트 만들기", category: "프로젝트 설정" },
      { name: "git-deploy", title: "Git 저장소로 첫 배포", category: "프로젝트 설정" },
      { name: "cli-setup", title: "Vercel CLI 설치와 연결", category: "CLI 배포" },
      { name: "environment-variables", title: "환경 변수 설정", category: "CLI 배포" },
      { name: "preview", title: "Preview 배포와 확인", category: "배포 흐름" },
      { name: "production", title: "Production 배포", category: "배포 흐름" },
      { name: "domains", title: "도메인 연결과 DNS", category: "배포 흐름" },
      { name: "spa-routing", title: "React SPA 새로고침 404 해결", category: "프레임워크 설정" },
      { name: "troubleshooting", title: "빌드 오류와 로그 확인", category: "운영" },
      { name: "rollback", title: "롤백과 안전한 운영", category: "운영" },
      { name: "complete", title: "처음부터 끝까지 실습", category: "마무리" },
    ],
    supabase: [
      { name: "intro", title: "Supabase란 무엇인가", category: "시작하기" },
      { name: "project", title: "프로젝트 만들기", category: "시작하기" },
      { name: "client-setup", title: "React 클라이언트 연결", category: "앱 연결" },
      { name: "cli-local", title: "CLI와 로컬 실행", category: "로컬 개발" },
      { name: "migrations", title: "Migration과 타입 생성", category: "로컬 개발" },
      { name: "auth", title: "회원가입과 로그인", category: "인증과 보안" },
      { name: "rls", title: "RLS 보안 정책", category: "인증과 보안" },
      { name: "database-crud", title: "Postgres CRUD", category: "데이터베이스" },
      { name: "storage", title: "Storage 파일 관리", category: "Supabase 서비스" },
      { name: "realtime", title: "Realtime 구독", category: "Supabase 서비스" },
      { name: "edge-functions", title: "Edge Functions 실행", category: "Supabase 서비스" },
      { name: "deploy", title: "원격 프로젝트에 반영", category: "배포와 운영" },
      { name: "troubleshooting", title: "오류 해결과 보안 점검", category: "배포와 운영" },
      { name: "complete", title: "처음부터 끝까지 실습", category: "마무리" },
    ],
    mysql: [
      { name: "intro", title: "MySQL이란 무엇인가", category: "시작하기" },
      { name: "install-windows", title: "Windows 설치", category: "시작하기" },
      { name: "server-connect", title: "서버 실행과 접속", category: "시작하기" },
      { name: "database-table", title: "Database와 Table", category: "SQL 기초" },
      { name: "data-types", title: "데이터 타입", category: "SQL 기초" },
      { name: "insert-select", title: "INSERT와 SELECT", category: "CRUD" },
      { name: "filter-sort", title: "WHERE와 정렬", category: "CRUD" },
      { name: "update-delete", title: "UPDATE와 DELETE", category: "CRUD" },
      { name: "aggregate", title: "집계와 GROUP BY", category: "데이터 조회" },
      { name: "constraints", title: "제약 조건과 관계", category: "데이터 설계" },
      { name: "joins", title: "JOIN으로 테이블 연결", category: "데이터 조회" },
      { name: "indexes", title: "인덱스와 EXPLAIN", category: "성능" },
      { name: "transactions", title: "트랜잭션", category: "안전한 변경" },
      { name: "users-permissions", title: "사용자와 권한", category: "운영" },
      { name: "backup-restore", title: "백업과 복구", category: "운영" },
      { name: "complete", title: "처음부터 끝까지 실습", category: "마무리" },
    ],
    postgresql: [
      { name: "intro", title: "PostgreSQL이란 무엇인가", category: "시작하기" },
      { name: "install-windows", title: "Windows 설치", category: "시작하기" },
      { name: "psql-connect", title: "서버 실행과 psql", category: "시작하기" },
      { name: "database-schema", title: "Database와 Schema", category: "SQL 기초" },
      { name: "data-types", title: "PostgreSQL 데이터 타입", category: "SQL 기초" },
      { name: "insert-select", title: "INSERT와 SELECT", category: "CRUD" },
      { name: "filter-sort", title: "WHERE와 정렬", category: "CRUD" },
      { name: "update-delete-upsert", title: "UPDATE·DELETE·UPSERT", category: "CRUD" },
      { name: "aggregate", title: "집계와 GROUP BY", category: "데이터 조회" },
      { name: "constraints", title: "제약 조건과 관계", category: "데이터 설계" },
      { name: "joins", title: "JOIN으로 테이블 연결", category: "데이터 조회" },
      { name: "indexes-explain", title: "인덱스와 EXPLAIN", category: "성능" },
      { name: "transactions-locks", title: "트랜잭션과 잠금", category: "안전한 변경" },
      { name: "roles-permissions", title: "역할과 최소 권한", category: "보안과 운영" },
      { name: "connections", title: "연결과 Connection Pool", category: "보안과 운영" },
      { name: "vacuum-monitor", title: "VACUUM과 모니터링", category: "보안과 운영" },
      { name: "backup-restore", title: "백업과 복구", category: "보안과 운영" },
      { name: "complete", title: "처음부터 끝까지 실습", category: "마무리" },
    ]

  };

  const currentDocs = (lang && docMenus[lang]) ? docMenus[lang] : [];
  
  // 카테고리별로 문서 그룹핑
  const groupedDocs: GroupedDocs = currentDocs.reduce((acc: GroupedDocs, doc: DocItem) => {
    if (!acc[doc.category]) {
      acc[doc.category] = [];
    }
    acc[doc.category].push(doc);
    return acc;
  }, {});

  useEffect(() => {
    if (!lang || !docName) return;

    setLoading(true);
    fetch(`/md/${lang}/${docName}.md?t=${Date.now()}`, { cache: "no-store" })
      .then((res) => {
        if (!res.ok) throw new Error("파일 없음");
        return res.text();
      })
      .then((text) => {
        setContent(text);
        setError(false);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, [lang, docName]);

  // ✅ 스크롤 맨 위로 이동하는 부분
useEffect(() => {
  window.scrollTo(0, 0);
}, [docName]);

  useEffect(() => {
    const handleResize = () => {
      setSidebarOpen(window.innerWidth > 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const getLanguageTitle = (lang: string | undefined): string => {
    const titles: { [key: string]: string } = {
      c: "C",
      csharp: "C#",
      cpp: "C++",
      java: "Java",
      html: "HTML",
      css: "CSS",
      javascript: "JavaScript",
      system: "System Programming",
      python: "Python",
      linux: "Linux",
      logic: "Digital Logic",
      git: "Git & GitHub",
      firebase: "Firebase",
      vercel: "Vercel",
      supabase: "Supabase",
      mysql: "MySQL",
      postgresql: "PostgreSQL",
      nextjs: "Next.js"
    };
    return (lang && titles[lang]) ? titles[lang] : (lang?.toUpperCase() || "문서");
  };

  return (
    <div className={`markdown-container ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
      {!sidebarOpen && (
        <button
          className="sidebar-open-toggle"
          onClick={toggleSidebar}
          aria-label="사이드바 열기"
        >
          ☰ 
        </button>
      )}

      <div
        className={`sidebar-backdrop ${sidebarOpen ? "show" : ""}`}
        onClick={() => setSidebarOpen(false)}
        aria-hidden="true"
      />
      
      <nav className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2 className="sidebar-title">{getLanguageTitle(lang)} 문서</h2>
          <Link to="/Menu" className="back-to-menu">
            ← 메뉴로 돌아가기
          </Link>
          <button
            className="sidebar-toggle"
            onClick={toggleSidebar}
            aria-label="사이드바 토글"
            aria-pressed={sidebarOpen}
          >
            <span className="toggle-icon">☰</span>
            <span className="toggle-label">{sidebarOpen ? "닫기" : "메뉴"}</span>
          </button>
          
        </div>
        
        <div className="sidebar-nav">
          {Object.entries(groupedDocs).map(([category, docs]) => (
            <div key={category} className="nav-section">
              <h3 className="nav-section-title">{category}</h3>
              <hr></hr>
              <ul className="nav-list">
                {docs.map((doc: DocItem) => (
                  <li key={doc.name} className="nav-item">
                    <Link 
                      to={doc.route ? doc.route : `/${lang}/${doc.name}`}
                      className={`nav-link ${docName === doc.name ? 'active' : ''}`}
                    >
                      {doc.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </nav>

      <main className="content-area">
        {loading && (
          <div className="loading">
            ⏳ 문서를 불러오는 중...
          </div>
        )}

        {error && (
          <div className="error">
            <h1>🚫 404 - 페이지를 찾을 수 없습니다</h1>
            <p>
              문서 <code>{`/md/${lang}/${docName}.md`}</code>가 존재하지 않습니다.
            </p>
          </div>
        )}

        {!loading && !error && (
          <div className="prose">
            {content.split(/(\[AD\]|\[8BIT_SIM\])/g).map((part, index) => {
              if (part === '[AD]') return <AdComponent key={`ad-${index}`} />;
              if (part === '[8BIT_SIM]') return <EightBitSimulator key={`sim-${index}`} />;
              return (
              <div key={`markdown-${index}`}>
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeHighlight]}
                  components={{
                    table: ({ node, ...props }) => (
                      <div className="table-scroll">
                        <table {...props} />
                      </div>
                    ),
                  }}
                >
                  {part}
                </ReactMarkdown>
              </div>
              );
            })}
          </div>
        )}
      </main>
    </div>
  );
}

export default MarkdownPage;
